import { MainContainer } from "../Contents/Contents.element";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomTabs from "../../ui/Tab";
import { ReactNode, useEffect, useState } from "react";
import Attributes from "./Attributes/Attributes";
import PageHeader from "../../layout/PageHeader";
import { IPlayerCardData } from "../../types/IPlayerDetail";
import { postData } from "../../services/api";
import apiUrls from "../../config/apiUrls";
import handleApiResponse from "../../utils/handleApiResponse";
import { ITab } from "../../types/ITab";
import { TabSectionStyles } from "../../styled-components/TabStyles";
import IApiResponse from "../../types/IApiResponse";
import { useSearch } from "../../contexts/PlayerSearchContext";
import { useLoading } from "../../contexts/LoadingContext";
import LoadingSpinner from "../../ui/LoadingSpinner";
import PlayerOverview from "./PlayerOverview";
import "./style.css";
import { PlayerContent } from "../../styled-components/PlayerCard.Styles";
import Overview from "./Overview/Overview";
import Candidate from "./Candidates/Candidate";
import PlayerFilterResultsPage from "../PlayerLanding/PlayerSearch/PlayerFilterResultsPage";
import { usePlayerSearch } from "../../contexts/SearchPlayersContext";
import { IPlayerSearchResponse, IPlayerZonePosition } from "../../types/IPlayerSearchResponse";
import { fetchPlayerZonePositionData } from "../../services/dataService";
import { IPlayerAttributesData } from "../../types/IPlayerAttributesData";
import { attributeSections } from "../../data/attributeSection";
import noImagePlayer from "../../assets/icons/noImagePlayer.svg";
import { useNotification } from "../../contexts/NotificationContext";
import PWNotification from "../PWNotification";
import { addUpdateSortListData } from "../PlayerComparison/addOrUpdateSortList";
import { useAuth } from "../../contexts/AuthContext";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import LabelText from "../../ui/LabelText";
import { useNewPlayerShortlistContext } from "../../contexts/NewPlayerShortlistContext";
import { useClubSearch } from "../../contexts/ClubSearchContext";

const TABS: ITab[] = [
  // { title :'Overview', key : 'Overview'},
  // { title: "Attributes", key: "Attributes" },
  { title: "Overview", key: "Overview" },
  //{ title: "Similar players", key: "Similarplayers" },
  { title: "Succession", key: "Similarplayers" },
  { title: "Club candidates", key: "Candidates" },
];

const PlayerDetail: React.FC<{ toggle: boolean; isSubSidebarOpen: boolean }> = (props) => {
  const { handleOriginPage, setIsClubsSelected, setPlayerName, playerName } = useSearch();
  const { loading, startLoading, stopLoading } = useLoading();
  const {
    handleSelectedPlayer,
    setIsPlayerFilterChange,
    selectedPlayers,
    handleSelectedPlayerZones,
    setAllProfiles,
    handleSelectedProfiles,
    isAllPosition,
    handleSelectedAttributes,
    setIsSearchByAttributes,
    setOriginPage,
    originPage,
    reset,
    toggleAddButton,
    setIsToggleAddButton,
  } = usePlayerSearch();
  const {
    showNotification,
    hideNotification,
    displayNotification,
    setDisplayNotification,
    notificationContent,
    setNotificationContent,
    setShouldHideAfterTimeout,
  } = useNotification();

  const navigate = useNavigate();
  const {setIsClubCompareId}=useClubSearch()
  const {setComparePlayerId } = usePlayerSearch()
  const {setSelectedGraph} = useSearch();
  const location = useLocation();
  const { userData } = useAuth();
  const { playerId } = useParams<{ playerId: string }>();
  const [displayCustomNotification, setDisplayCustomNotification] = useState<boolean>(false);
  const [customNotificationContent, setCustomNotificationContent] = useState<ReactNode>(null);
  const [playerData, setPlayerData] = useState<IPlayerCardData>();
  const [activeTab, setActiveTab] = useState<string>("Overview");
  const [selectedSimilarPlayer, setSelectedSimilarPlayer] = useState<IPlayerSearchResponse[]>([]);
  const [addedPlayerShortList, setAddedPlayerShortList] = useState<boolean>(false);
  const { newlyAddedPlayerCount, setNewlyAddedPlayerCount } = useNewPlayerShortlistContext();  


  useEffect(()=>{
    if(Number(playerId!) > 0){
      setSelectedGraph('Football')
    }
  },[playerId!])

  const fetchData = async () => {
    try {
      const params = new URLSearchParams(location.search);
      const activeTabFromUrl = params.get("tab");
      const ApiRequestData = {
        playerId: playerId,
      };
      const response: IApiResponse<IPlayerCardData> = await postData(apiUrls.GetPlayerCardDetail, ApiRequestData);
      handleApiResponse(
        response,
        async (playerData) => {
          setPlayerData(playerData);
          setPlayerName(`${playerData?.givenName} ${playerData?.familyname}`);
          setIsToggleAddButton(playerData.isPlayerInShortlist);
          if (activeTabFromUrl) {
            //reset();
            const selectedPlayer: IPlayerSearchResponse = {
              playerName: playerData.playerLabel,
              playerClub: playerData.clubName,
              playerClubURL: playerData.clubImageURL,
              playerId: playerData.playerId,
              playerImageURL: playerData.playerImageURL,
              isEasternPlayer: playerData.isEasternPlayer,
              givenName: playerData.givenName,
              familyName: playerData.familyname,
            };
            handleSelectedPlayer([selectedPlayer]);
            setActiveTab("Similarplayers");
            setOriginPage("Similarplayers Tab");
            await fetchPlayerZonePosition(Number(playerId));
            await fetchAttributesData(Number(playerId));
            setIsPlayerFilterChange(true);
          } else {
            setActiveTab("Overview");
          }
        },
        (error) => {
          console.error("Error fetching PlayerCard Data:", error);
        }
      );

      // Determine active tab and origin
      // if (activeTabFromUrl) {

      //     setActiveTab('Similarplayers');
      //     setOriginPage('Similarplayers Tab');
      //     await fetchPlayerZonePosition(Number(playerId));
      //     await fetchAttributesData(Number(playerId));
      //     setIsPlayerFilterChange(true);
      // } else {
      //     setActiveTab('Attributes');
      // }
    } catch (error) {
      console.error("Error in fetchData:", error);
    }
  };

  useEffect(() => {
    setIsClubCompareId(0)
    setComparePlayerId(0)
    fetchData();
  }, [location.search, playerId]);

  const fetchPlayerZonePosition = async (playerId: number) => {
    startLoading();
    try {
      const response: IApiResponse<IPlayerZonePosition> = await fetchPlayerZonePositionData(playerId);
      if (response.isSuccess) {
        const playerZonePositionData = response.data;
        handleSelectedPlayerZones(playerZonePositionData.zones || []);
        const allPositionList = playerZonePositionData?.position?.playerPositions || [];
        setAllProfiles(allPositionList);
        // const selectedProfileItems = playerZonePositionData.position?.selectedPosition || [];
        // const filteredPositions = allPositionList.filter((position) => selectedProfileItems.includes(position.positionId));
        // const positionIdsArray: number[] = selectedProfileItems.map((position) => position.positionId);
        handleSelectedProfiles(playerZonePositionData?.position?.playerPositions?.map(position => position?.positionId) || []);
      } else {
        console.error(response.error?.message || "Error fetching player zone position data");
      }
    } finally {
      stopLoading();
    }
  };

  const fetchAttributesData = async (playerId: number) => {
    
    startLoading();
    try {
      const requestParameters = {
        playerId: playerId,
        AllPosition: isAllPosition === "allpositions",
        AttributeScoreFor: "universe",
        seasonId: 0,
      };
      const response: IApiResponse<IPlayerAttributesData> = await postData(apiUrls.GetPlayerAttributes, requestParameters);
      if (response.isSuccess) {
        const attributesData = response.data;
        const playerAttributesUniverse = attributesData?.playerAttributesUniverseTheirPos;
        const updatedSections = attributeSections.map((section) => ({
          ...section,
          attributes: section.attributes.map((attribute) => {
            let score: number | null = null;
            switch (attribute.id) {
              case "Height Cm":
                score = attributesData.heightInCM;
                break;
              case "Av. contribution score":
                score = playerAttributesUniverse?.overall?.performanceValue;
                break;
              case "finishing-shots":
                score = playerAttributesUniverse?.finalThird?.finishingShots?.score;
                break;
              case "finishing-aerial":
                score = playerAttributesUniverse?.finalThird?.finishingAerial?.score;
                break;
              case "attack-positioning":
                score = playerAttributesUniverse?.finalThird?.attackPositioning?.score;
                break;
              case "creativity":
                score = playerAttributesUniverse?.buildUpPlay?.creativity?.score;
                break;
              case "passing-accuracy":
                score = playerAttributesUniverse?.buildUpPlay?.passingAccuracy?.score;
                break;
              case "dribbling":
                score = playerAttributesUniverse?.buildUpPlay?.dribbling?.score;
                break;
              case "crossing":
                score = playerAttributesUniverse?.buildUpPlay?.crossing?.score;
                break;
              case "tackling":
                score = playerAttributesUniverse?.defence?.tackling?.score;
                break;
              case "defensive-headers":
                score = playerAttributesUniverse?.defence?.defensiveHeaders?.score;
                break;
              case "aggression":
                score = playerAttributesUniverse?.defence?.aggression?.score;
                break;
              default:
                return attribute; // If no match, return the original attribute
            }
            return {
              ...attribute,
              checked: score !== null && score !== 0, // Set checked to true only if score is not null and not 0
              percentile: score,
            };
          }),
        }));
        const selectedAttributelist = updatedSections.flatMap((section) => section.attributes).filter((attribute) => attribute.checked);
        handleSelectedAttributes(selectedAttributelist);
        setIsSearchByAttributes(selectedAttributelist.length > 0 ? true : false);
      }
    } finally {
      stopLoading();
    }
  };

  const handleTabClick = async (key: string) => {
    window.scrollTo(0, 0);
    if (key === "Similarplayers") {
      reset();
      handleOriginPage("Similarplayers Tab");
      setOriginPage("Similarplayers Tab");
      if (playerData !== undefined) {
        const selectedPlayer: IPlayerSearchResponse = {
          playerName: playerData.playerLabel,
          playerClub: playerData.clubName,
          playerClubURL: playerData.clubImageURL,
          playerId: playerData.playerId,
          playerImageURL: playerData.playerImageURL,
          isEasternPlayer: playerData.isEasternPlayer,
          givenName: playerData.givenName,
          familyName: playerData.familyname,
        };

        handleSelectedPlayer([selectedPlayer]);
        setSelectedSimilarPlayer([selectedPlayer]);
        await fetchPlayerZonePosition(playerData.playerId);
        await fetchAttributesData(playerData.playerId);
        setIsPlayerFilterChange(true);
      }
    }
    setActiveTab(key);
    hideNotification();
    setDisplayNotification(false);
    setNotificationContent(null);
    setShouldHideAfterTimeout(false);
    setIsClubsSelected(false);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "Similarplayers":
        return (
          <div className="player-tab-content player-filter-result">
            <PlayerFilterResultsPage selectedSimilarPlayer={selectedSimilarPlayer} club={Number(playerData?.loanClubId! > 0 ? playerData?.loanClubId : playerData?.clubId)} 
              isFromSuccession={true}/>
          </div>
        );
      case "Attributes":
        return <Attributes playerData={playerData} playerId={Number(playerId)} playerName={playerName} club={Number(playerData?.clubId)} isGoalKeeper={playerData?.isGoalKeeper} />;
      case "Overview":
        return <Overview playerId={Number(playerId)} playerName={playerName} playerData={playerData} />;
      case "Candidates":
        return (
          <div className="player-tab-content">
            <Candidate playerId={Number(playerId)} playerClubURL={playerData?.clubImageURL!} />
          </div>
        );
      default:
        return null;
    }
  };

  const handleAddPlayer = () => {
    setNewlyAddedPlayerCount((prev) => prev + 1);
    setIsToggleAddButton(!toggleAddButton);
    if (toggleAddButton) {
      setAddedPlayerShortList(false);
      addUpdateSortListData(
        userData,
        [playerData?.playerId!],
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        true,
        navigate
      );
    } else {
      setAddedPlayerShortList(true);
      addUpdateSortListData(
        userData,
        [playerData?.playerId!],
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        false,
        navigate
      );
    }
  };

  const handleActions = () => {
    setIsToggleAddButton(!toggleAddButton);
    addUpdateSortListData(
      userData,
      [playerData?.playerId!],
      startLoading,
      stopLoading,
      setDisplayCustomNotification,
      setCustomNotificationContent,
      false,
      navigate
    );
  };

  useEffect(() => {
    setCustomNotificationContent(
      <div className="notification">
        <p className="sortlist-notofication-content">
          <BookmarkBorderOutlinedIcon className="icon" />
          <LabelText className="squad-chart-tooltip notification-content">
            {!addedPlayerShortList ? "Player removed from your shortlist" : "Player added to your shortlist"}
          </LabelText>

          {!addedPlayerShortList ? (
            <LabelText className="player-given-name notification-content" style={{ cursor: "pointer" }} onClick={() => handleActions()}>
              Undo
            </LabelText>
          ) : (
            <LabelText
              className="player-given-name notification-content"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/shortlists")}
            >
              View shortlist
            </LabelText>
          )}
        </p>
      </div>
    );
  }, [displayCustomNotification]);

  return (
    <MainContainer active={props.toggle} isSubSidebarOpen={props.isSubSidebarOpen} className={"main-container player-detail-page"}>
      <PageHeader
        img={playerData?.playerImageURL ? playerData?.playerImageURL : noImagePlayer}
        playerIds={playerData?.playerId!}
        name={playerData?.familyname}
        playerName={playerData?.givenName}
        handleAddPlayer={handleAddPlayer}
        isBookmark={false}
        isSimulate={false}
        isShare={false}
        isCompare={false}
        isAddtoSortlis={true}
        isPlayerInShortlist={toggleAddButton}
        pageName="player-detail"
      />
      {playerData && <PlayerOverview playerData={playerData} />}
      <PlayerContent className="main-player-container-new">
        <TabSectionStyles className="tab-section" style={{ zIndex: 3}}>
          <CustomTabs tabs={TABS} activeTabKey={activeTab} onTabClick={handleTabClick} />
        </TabSectionStyles>
        {renderTabContent()}
      </PlayerContent>
      {loading && activeTab !== "Similarplayers" && activeTab !== "Candidates" && <LoadingSpinner />}
      {displayCustomNotification && (
        <PWNotification
          message={customNotificationContent}
          setIsNotification={() => setDisplayCustomNotification(false)}
          isDisplayCloseIcon={true}
          className="player-filter-notification add-similar-notification"
        />
      )}
    </MainContainer>
  );
};

export default PlayerDetail;
